import { z } from 'zod';

export const TextSize = z.enum([
  'text-xs',
  'text-sm',
  'text-md',
  'text-base',
  'text-lg',
  'text-xl',
  'text-2xl',
  'text-3xl',
  'text-4xl',
]);
export type TextSize = z.infer<typeof TextSize>;

export const SmTextSize = z.enum([
  'sm:text-xs',
  'sm:text-sm',
  'sm:text-base',
  'sm:text-lg',
  'sm:text-xl',
  'sm:text-2xl',
  'sm:text-3xl',
  'sm:text-4xl',
]);

export type SmTextSize = z.infer<typeof SmTextSize>;

export const MdTextSize = z.enum([
  'md:text-xs',
  'md:text-sm',
  'md:text-base',
  'md:text-lg',
  'md:text-xl',
  'md:text-2xl',
  'md:text-3xl',
  'md:text-4xl',
]);

export type MdTextSize = z.infer<typeof MdTextSize>;

export const LgTextSize = z.enum([
  'lg:text-xs',
  'lg:text-sm',
  'lg:text-base',
  'lg:text-lg',
  'lg:text-xl',
  'lg:text-2xl',
  'lg:text-3xl',
  'lg:text-4xl',
]);

export type LgTextSize = z.infer<typeof LgTextSize>;

export const XlTextSize = z.enum([
  'xl:text-xs',
  'xl:text-sm',
  'xl:text-base',
  'xl:text-lg',
  'xl:text-xl',
  'xl:text-2xl',
  'xl:text-3xl',
  'xl:text-4xl',
]);

export type XlTextSize = z.infer<typeof XlTextSize>;

export const XxlTextSize = z.enum([
  '2xl:text-xs',
  '2xl:text-sm',
  '2xl:text-base',
  '2xl:text-lg',
  '2xl:text-xl',
  '2xl:text-2xl',
  '2xl:text-3xl',
  '2xl:text-4xl',
]);

export type XxlTextSize = z.infer<typeof XxlTextSize>;

export const XxxlTextSize = z.enum([
  '3xl:text-xs',
  '3xl:text-sm',
  '3xl:text-base',
  '3xl:text-lg',
  '3xl:text-xl',
  '3xl:text-2xl',
  '3xl:text-3xl',
  '3xl:text-4xl',
]);

export type XxxlTextSize = z.infer<typeof XxxlTextSize>;

export const TextColor = z.enum([
  'text-secondary',
  'text-gray-600',
  'text-gray-700',
  'text-gray-800',
  'text-gray-900',
  'text-gray-1000',
  'text-white',
  'text-black',
  'text-green-600',
  'text-red-600',
  'text-blue-800',
]);
export type TextColor = z.infer<typeof TextColor>;

export const S2FontFamily = z.enum(['font-sans', 'font-serif']);
export type S2FontFamily = z.infer<typeof S2FontFamily>;

export const FontWeight = z.enum([
  'font-normal',
  'font-light',
  'font-extralight',
  'font-semibold',
  'font-bold',
  'font-black',
]);
export type FontWeight = z.infer<typeof FontWeight>;

export const safeTwClass = <
  TwType extends TextSize | TextColor | S2FontFamily | FontWeight,
>({
  defaultValue,
  override,
}: {
  defaultValue: TwType;
  override?: TwType;
}) => {
  return override ?? defaultValue;
};
